import Vue from "vue";
import VueRouter from "vue-router";
import { RouterRegister } from "./register";
import { RouterHome } from "./home";
import { RouterNormal } from "./normal";
import { RouterSub } from "./sub";
import { RouterYear } from "./year";
import { RouterPayment } from "./payment";
import { RouterOrder } from "./order";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name:"首页",
    component: resolve => require(/* webpackChunkName: "home" */ ["@/views/home/Index.vue"], resolve),
  },
  ...RouterRegister,
  ...RouterHome,
  ...RouterNormal,
  ...RouterSub,
  ...RouterYear,
  ...RouterPayment,
  ...RouterOrder,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
